import { useTranslation } from 'react-i18next'

import { DATE_FORMAT, formatDate } from 'utils/date'

export const DurationCell = ({ date }: { date?: Date }): JSX.Element | string => {
  const { t } = useTranslation('components')

  return date ? formatDate(date, DATE_FORMAT.WITH_TIME) : t('table.emptyCell')
}
